import React, { ReactElement, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import useForceUpdate from "use-force-update";
import { object, string } from "yup";
import { Application, ApplicationService } from "../";
import { InputErrorMessage } from "../../ui";

interface IProps {
	application: Application;
	jumpToStep?: any;
	nextStep: number;
}

export const StepDeclaration = (props: IProps): ReactElement => {
	const [errors, setErrors] = useState(null);
	const forceUpdate = useForceUpdate();
	const applicationService = new ApplicationService();

	if (props.application.currentStep < 6) {
		props.application.currentStep = 6;
	}

	const schema = object({
		declarationFullname: string().required("Please enter your full name"),
	});

	const validateStep = () => {
		schema
			.validate(
				{
					declarationFullname: props.application.declarationFullname,
				},
				{ abortEarly: false },
			)
			.then(valid => {
				if (valid) {
					setErrors(null);
					applicationService.updateApplication(
						props.application,
						true,
					);
					props.jumpToStep(props.nextStep);
				}
			})
			.catch(err => {
				setErrors(err);
			});
	};

	return (
		<>
			<Row className="mb-4">
				<Col>
					<h3 className="mb-4 mt-4">Declaration</h3>
					<ol style={{ maxWidth: "80%" }}>
						<li>
							By typing your full name below you agree to abide by
							the policies, rules and regulations of the
							institution.
						</li>
						<li>
							By typing your full name below you understand that
							the institution has the right to exclude any student
							at any time in keeping with its regulations, when
							such an act is deemed to be in the best interest of
							either the student, student body, or the
							institution.
						</li>
						<li>
							y typing your full name below you agree that
							falsification of information or withholding
							information requested may make you ineligible for
							admission or continuation of studies.
						</li>
					</ol>
				</Col>
			</Row>
			<Row className="mb-4 mt-2">
				<Col md={8} xs={12}>
					<Form.Group controlId="lastName">
						<Form.Label>Full Name *</Form.Label>
						<Form.Control
							size="lg"
							onChange={(event: any) => {
								props.application.declarationFullname =
									event.target.value;
								forceUpdate();
							}}
							defaultValue={props.application.declarationFullname}
						/>
						<InputErrorMessage
							errors={errors}
							field="declarationFullname"
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col>
					<Button
						variant="primary"
						size="lg"
						className="pull-left btn-next"
						onClick={() => props.jumpToStep(props.nextStep - 2)}
					>
						Previous
					</Button>
					<Button
						variant="primary"
						size="lg"
						className="float-right btn-next"
						onClick={validateStep}
					>
						Submit Application
					</Button>
				</Col>
			</Row>
		</>
	);
};
